<template>
  <div class="qr-code">
    <img :src="qr" :alt="itemName">
    <a :href="qr" :download="itemName">download</a>
  </div>
</template>

<script>
  import QRCode from 'qrcode';

  export default {
    // node component https://github.com/soldair/node-qrcode
    name: 'QRCode',

    props: {
      itemRendered: String,
      itemName: String,
    },

    data() {
      return {
        qr: null
      }
    },

    components: {
      QRCode,
    },

    methods: {
      makeQRCode() {
        let qrCode
        QRCode.toDataURL(this.itemRendered, { type: 'image/jpeg', quality: 1, margin: 0, errorCorrectionLevel: 'H' }, function (err, string) {
          if (err) throw err
          qrCode = string
        })
        return this.qr = qrCode
      },
    },

    created() {
      this.makeQRCode()
    },
    
    watch: {
      itemRendered: function () {
        this.makeQRCode()
      }
    }
  }
</script>
